var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewestIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM10.5 2a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h2a.5.5 0 000-1H11V2.5a.5.5 0 00-.5-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5c0-2.757-2.243-5-5-5S6 2.243 6 5v.5a.5.5 0 001 0V5c0-2.206 1.794-4 4-4s4 1.794 4 4a4.007 4.007 0 01-3 3.873V7L9 9.5l3 2.5V9.899c2.28-.465 4-2.485 4-4.899z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewestIcon);
export default __webpack_public_path__ + "static/media/newest-icon.3f8d6139050c96fb145ffb0a3c150f1b.svg";
export { ForwardRef as ReactComponent };